<app-spinner
  [isVisible]="spinnerShow"
  [isFullscreen]="spinnerFullscreen"
  [size]="spinnerSize"
  [color1]="color1"
></app-spinner>

<div class="h-screen flex flex-col">
  <router-outlet class="flex-1 min-h-0 overflow-hidden"></router-outlet>
</div>
